import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

// The active employer lets its admins and record viewers read the litterat of
// projects where its employees work (the admin calendars).
export const getProjectAssignments = async (
  projectId,
  activeEmployerBusinessId
) => {
  const apiPath = `projects/${projectId}/assignments`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo: { activeEmployerBusinessId },
  });

  const response = await axios(signedRequest);

  return response.data;
};
